import { determineRangeValueColor } from 'utils/themes';

/**
 * determineTrendColor
 * Determines the number trend color based on combination of options.
 *
 * @param { Boolean } trendUp: If the trend direction is up.
 * @param { String } upColor: Trend up color.
 * @param { String } downColor: Trend down color.
 * @param { Boolean } custom: If the trend is a custom color.
 * @param { String } customColor: Color of trend if custom.
 * @returns { String } The color of the trend.
 */
export const determineTrendColor = (trendUp, upColor, downColor, custom, customColor) => {
  if (custom) {
    return customColor;
  }
  return trendUp ? upColor : downColor;
};

/**
 * determineRangeColor
 * Determines the number color based on where the value falls in the range thresholds.
 *
 * @param { Number } currentValue: The current value.
 * @param { Object } rangeTheme: Theme definition of the range.
 * @param { Array } rangeThresholds: Array of range thresholds containg values and colors.
 * @returns { Object } The range color object styles.
 */
export const determineRangeColor = (currentValue, rangeTheme = {}, rangeThresholds = []) => {
  const { customTheme, reverse, themeName, min: minValue, max: maxValue } = rangeTheme;
  let displayColor = '';

  if (customTheme) {
    rangeThresholds.some(({ color, value }) => {
      const valueIsGreater = currentValue > value;
      if (valueIsGreater) {
        displayColor = color;
      }
      return !valueIsGreater;
    });
  } else {
    displayColor = determineRangeValueColor(currentValue, minValue, maxValue, themeName, reverse);
  }

  return {
    invertBackgroundColor: displayColor,
    numberColor: displayColor,
  };
};
